import { React, useState, useEffect } from "react";
import * as ReactDOM from "react-dom";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { Input } from "@progress/kendo-react-inputs";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { GridHelper } from "../Common/Components/GridHelper";
import { ColumnMenu } from "../Common/Components/ColumnMenu";
import {
  GridColumnMenuFilter,
  GridColumnMenuCheckboxFilter,
} from "@progress/kendo-react-grid";

import { SvgIcon } from "@progress/kendo-react-common";
import * as svgIcons from "@progress/kendo-svg-icons";
import { useSelector } from "react-redux";
import { getSearchSelector } from "./SearchSlice";
import { useAppDispatch } from "../Core/store.hooks";

import { useNavigate } from "react-router-dom";

const initialSort: any[] = [
  {
    field: "customerName",
    dir: "asc",
  },
];

interface CustomerGridProps {
  data?: any | null;
  recent?: boolean | null;
}

const CustomerGrid = (props: CustomerGridProps) => {
  const [data, setData] = useState(props.data);
  const [sort, setSort] = useState(initialSort);
  const [isPagable, updateIsPagable] = useState(true);
  const [page, setPage] = useState({
    skip: 0,
    take: 10,
  });
  const pageChange = (event) => {
    setPage(event.page);
  };

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const params = useSelector(getSearchSelector);

  const countryFilter = useSelector(getSearchSelector).country;

  useEffect(() => {
    if (params != null) {
      if (params.searchAll != null) {
        filterData(params);
      }
    }
  }, [params]);

  //useEffect(() => {
  //    if (countryFilter!= null) {
  //        filterCountry(countryFilter)
  //        }

  //}, [countryFilter])

  const ColumnMenuCheckboxFilter = (props) => {
    return (
      <div>
        <GridColumnMenuCheckboxFilter {...props} data={data} expanded={true} />
      </div>
    );
  };

  const ColumnHeader = (props) => {
    return (
      <span
        style={{
          fontWeight: "bold",
        }}
      >
        {props.title}
      </span>
    );
  };
  function searchBySerial(x, machineSerialFilter) {
    if (machineSerialFilter == "" || machineSerialFilter == null) return true;
    if (x.machines == null || x.machines == undefined) return false;
    if (x.machines.length < 1) return false;
    for (var i = 0; i < x.machines.length; i++) {
      const assemblyName =
        x.machines[i].assemblyName != null
          ? x.machines[i].assemblyName.toLowerCase()
          : "";
      const machineSerialFull =
        assemblyName != null
          ? assemblyName + " " + x.machines[i].machineSn.toLowerCase()
          : x.machines[i].machineSn.toLowerCase();

      if (
        machineSerialFull.indexOf(machineSerialFilter.toLowerCase()) != -1 ||
        machineSerialFilter == null ||
        machineSerialFilter == ""
      ) {
        return true;
      }
      if (
        x.machines[i].deviceSerials != null &&
        x.machines[i].deviceSerials != undefined
      ) {
        for (var k = 0; k < x.machines[i].deviceSerials.length; k++) {
          if (x.machines[i].deviceSerials[k] != null) {
            if (
              x.machines[i].deviceSerials[k]
                .toLowerCase()
                .indexOf(machineSerialFilter.toLowerCase()) != -1
            ) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  function searchByProjectNr(x, projectNrFilter) {
    if (projectNrFilter == "" || projectNrFilter == null) return true;
    if (x.machines == null || x.machines == undefined) return false;
    if (x.machines.length < 1) return false;
    for (var i = 0; i < x.machines.length; i++) {
      if (
        x.machines[i].projectNr != null &&
        x.machines[i].projectNr != "" &&
        x.machines[i].projectNr != undefined
      ) {
        if (
          x.machines[i].projectNr
            .toLowerCase()
            .indexOf(projectNrFilter.toLowerCase()) != -1
        ) {
          return true;
        }
      }
    }
    return false;
  }
  function filterByAll(dataRow, value) {
    if (dataRow.customerID.toLowerCase().includes(value.toLowerCase())) {
      return true;
    }
    if (dataRow.customerName.toLowerCase().includes(value.toLowerCase())) {
      return true;
    }
    if (dataRow.customerID.toLowerCase().includes(value.toLowerCase())) {
      return true;
    }
    if (dataRow.country != null) {
      if (dataRow.country.toLowerCase().includes(value.toLowerCase())) {
        return true;
      }
    }
    if (dataRow.customerID_Italy != null) {
      if (
        dataRow.customerID_Italy.toLowerCase().includes(value.toLowerCase())
      ) {
        return true;
      }
    }

    return false;
  }
  const filterData = (value) => {
    let filter: any = {
      logic: "or",
      filters: [
        {
          field: "customerName",
          operator: "contains",
          value: value.searchAll,
        },
        {
          field: "customerID",
          operator: "contains",
          value: value.searchAll,
        },
        {
          field: "country",
          operator: "contains",
          value: value.searchAll,
        },
      ],
    };
    let customerIDFilter: any = {
      logic: "or",
      filters: [
        {
          field: "customerID",
          operator: "contains",
          value: value.customerID,
        },
        {
          field: "customerID_Italy",
          operator: "contains",
          value: value.customerID,
        },
      ],
    };
    let countryFilter: any = {
      logic: "or",
      filters: [
        {
          field: "country",
          operator: "contains",
          value: value.country,
        },
      ],
    };
    let newData = props.data;
    if (value.country != "") {
      newData = filterBy(newData, countryFilter);
    }
    if (value.customerID != "") {
      newData = filterBy(newData, customerIDFilter);
    }

    if (value.machineSerial != "") {
      let machineSerialTrue = [];

      for (var i = 0; i < newData.length; i++) {
        if (searchBySerial(newData[i], value.machineSerial)) {
          machineSerialTrue.push(newData[i]);
        }
      }
      newData = machineSerialTrue;
    }
    if (value.projectNr != "") {
      let projectNrTrue = [];

      for (var i = 0; i < newData.length; i++) {
        if (searchByProjectNr(newData[i], value.projectNr)) {
          projectNrTrue.push(newData[i]);
        }
      }
      newData = projectNrTrue;
    }
    if (value.searchAll != "") {
      let rowTrue = [];

      for (var i = 0; i < newData.length; i++) {
        if (
          searchByProjectNr(newData[i], value.searchAll) ||
          searchBySerial(newData[i], value.searchAll) ||
          filterByAll(newData[i], value.searchAll)
        ) {
          rowTrue.push(newData[i]);
        }
      }
      newData = rowTrue;
    }
    setPage({
      skip: 0,
      take: 10,
    });
    setData(newData);
  };

  const customerHandler = (customer: any) => {
    // navigate("/customers/customerId=" + customer.customerID)
  };

  const machineHandler = (machine: string, customerID: string) => {
    //let recentCustomers: any = JSON.parse(localStorage.getItem("recentCustomers"));
    //if (recentCustomers == null || recentCustomers == undefined) recentCustomers = [];
    //var alreadyRecent = false;
    //for (var i = 0; i < recentCustomers.length; i++) {
    //    if (recentCustomers[i].customerID == customer.customerID) {
    //        alreadyRecent = true;
    //        // Update if name changed etc.
    //        recentCustomers[i] = customer;
    //        // put this customer to the top of the list
    //        recentCustomers.splice(0,
    //            0,
    //            recentCustomers.splice(i, 1)[0]);
    //    }
    //}

    //if (!alreadyRecent) {
    //    recentCustomers.unshift(customer);

    //    if (recentCustomers.length > 4) {
    //        recentCustomers.pop();
    //    }
    //    localStorage.setItem("recentCustomers", JSON.stringify(recentCustomers));
    //}
    navigate("/customers/customerId=" + customerID + "&machine=" + machine);
  };

  const customerNameCell = (props: any) => {
    const renderLock = () => {
      if (props.dataItem.hasMACAddress) {
        return (
          <SvgIcon
            style={{
              color: "#474747",
              fontSize: "20px",
              marginLeft: "5px",
              verticalAlign: "top",
              top: "2px",
            }}
            icon={svgIcons.lockIcon}
            size="medium"
          />
        );
      }
      return "";
    };
    return (
      <td
        style={{ cursor: "pointer" }}
        onClick={() => customerHandler(props.dataItem)}
      >
        {props.dataItem.customerName}
        {renderLock()}
      </td>
    );
  };
  const machineSerialCell = (cellprops: any) => {
    //const getAssemblyName = (a:any) => {
    //    if (a.assemblyName != null) return a.assemblyName;
    //    return" "
    //}
    //if (props.dataItem.machines.length < 1) {
    //    return (<td></td>)
    //}
    //else if (props.dataItem.machines.length == 1) {

    //    return (<td onClick={() => machineHandler(props.dataItem.machines[0].machineSn, props.dataItem.customerID)}  >{getAssemblyName(props.dataItem.machines[0]) +" "+props.dataItem.machines[0].machineSn}</td>)
    //}
    //else {
    //    let machines: any = [];

    //    for (var i = 0; i < props.dataItem.machines.length; i++) {
    //        machines.push(getAssemblyName(props.dataItem.machines[i]) +" "+ props.dataItem.machines[i].machineSn)
    //    }
    //    const findSerial = (e) => {
    //        for (var i = 0; i < props.dataItem.machines.length; i++) {
    //            if (e == (getAssemblyName(props.dataItem.machines[i]) + " " + props.dataItem.machines[i].machineSn)) {
    //                return props.dataItem.machines[i].machineSn;
    //            }
    //        }
    //    }
    //    return (<td>
    //        <ComboBox
    //            style={{
    //                width: "300px",
    //            }}
    //            data={machines}
    //            placeholder="Select machine..."
    //            onChange={(e) => machineHandler(findSerial(e.target.value), props.dataItem.customerID)}
    //        /></td>
    //        )
    //}
    const listItems = cellprops.dataItem.machines.map((machine) => (
      <li>{machine.machineSn}</li>
    ));
    return <td>{listItems}</td>;
  };
  const getHeight = () => {
    if (props.recent) {
      return "200px";
    } else {
      return "100%";
    }
  };

  return (
    <div>
      <p>
        Below is the list of customers retreived using the PST api. This list
        shows only customers with customer ID not found in D365 database or the
        MPE database.
      </p>
      <Grid
        pageable={isPagable}
        data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
        skip={page.skip}
        take={page.take}
        onPageChange={pageChange}
        total={data.length}
        sortable={true}
        sort={sort}
        onSortChange={(e: any) => {
          setSort(e.sort);
        }}
        style={{
          width: "1000px",
          height: getHeight(),
        }}
      >
        <Column field="country" title="Country" />
        <Column
          field="customerName"
          title="Customer Name"
          cell={customerNameCell}
        />

        <Column field="customerID" title="Customer ID" />
        <Column
          field="machines"
          title="Machine Serials"
          cell={machineSerialCell}
        />
        <Column field="street" title="Address" />
      </Grid>
    </div>
  );
};
export default CustomerGrid;
